import { format } from 'date-fns';
import { useEffect, useState } from 'react';

import { Calendar } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';

interface CustomDatePickerProps {
  onUpdate: (newText: string) => void;
  text: string;
}

const CustomDatePicker = ({ onUpdate, text }: CustomDatePickerProps) => {
  const [date, setDate] = useState<Date>();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!date) return;
    onUpdate(text.replace('Custom', format(date, 'MM/dd/yyyy')));
  }, [date, onUpdate, text]);

  return (
    <div>
      @{text.split(':')[0]}
      {': '}
      <Popover
        onOpenChange={setOpen}
        open={open}
      >
        <PopoverTrigger asChild>
          <button
            className="font-mono underline"
            data-empty={!date}
            type="button"
          >
            {date ? format(date, 'MM/dd/yyyy') : <span>Select a day</span>}
          </button>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto p-0"
          side="top"
        >
          <Calendar
            disabled={
              text.startsWith('As of Date:') ? { after: new Date() } : undefined
            }
            mode="single"
            onSelect={date => {
              setDate(date);
              setOpen(false);
            }}
            selected={date}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default CustomDatePicker;
